import { MediaMetadata } from '@/types/storage';

export const BGM_PRESETS: MediaMetadata[] = [
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/1.About%20That%20Oldie%20-%20Vibe%20Tracks.mp3",
        "storageType": "url",
        "fileName": "1.About That Oldie - Vibe Tracks.mp3",
        "fileSize": 4560000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/2.Alternate%20-%20Vibe%20Tracks.mp3",
        "storageType": "url",
        "fileName": "2.Alternate - Vibe Tracks.mp3",
        "fileSize": 6900000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/3.Beat%20Your%20Competition%20-%20Vibe%20Tracks.mp3",
        "storageType": "url",
        "fileName": "3.Beat Your Competition - Vibe Tracks.mp3",
        "fileSize": 6950000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/4.Bike%20Rides%20-%20The%20Green%20Orbs.mp3",
        "storageType": "url",
        "fileName": "4.Bike Rides - The Green Orbs.mp3",
        "fileSize": 0,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/5.Bumper%20Tag%20-%20John%20Deley.mp3",
        "storageType": "url",
        "fileName": "5.Bumper Tag - John Deley.mp3",
        "fileSize": 0,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/6.Claudio%20The%20Worm%20-%20The%20Green%20Orbs.mp3",
        "storageType": "url",
        "fileName": "6.Claudio The Worm - The Green Orbs.mp3",
        "fileSize": 0,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/7.Cuckoo%20Clock%20-%20Quincas%20Moreira.mp3",
        "storageType": "url",
        "fileName": "7.Cuckoo Clock - Quincas Moreira.mp3",
        "fileSize": 0,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/8.Cute%20Avalanche%20-%20RKVC.mp3",
        "storageType": "url",
        "fileName": "8.Cute Avalanche - RKVC.mp3",
        "fileSize": 0,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/9.Da%20Jazz%20Blues%20-%20Doug%20Maxwell...Media%20Right%20Productions.mp3",
        "storageType": "url",
        "fileName": "9.Da Jazz Blues - Doug Maxwell...Media Right Productions.mp3",
        "fileSize": 0,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/10.Dog%20and%20Pony%20Show%20-%20Silent%20Partner.mp3",
        "storageType": "url",
        "fileName": "10.Dog and Pony Show - Silent Partner.mp3",
        "fileSize": 3730000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/11.Fights%20-%20Silent%20Partner.mp3",
        "storageType": "url",
        "fileName": "11.Fights - Silent Partner.mp3",
        "fileSize": 3780000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/12.Get%20Outside!%20-%20Jason%20Farnham.mp3",
        "storageType": "url",
        "fileName": "12.Get Outside! - Jason Farnham.mp3",
        "fileSize": 3620000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/13.Happy%20Mistake%20-%20RKVC.mp3",
        "storageType": "url",
        "fileName": "13.Happy Mistake - RKVC.mp3",
        "fileSize": 7200000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/14.How%20it%20Began%20-%20Silent%20Partner.mp3",
        "storageType": "url",
        "fileName": "14.How it Began - Silent Partner.mp3",
        "fileSize": 7300000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/15.If%20I%20Had%20a%20Chicken%20-%20Kevin%20MacLeod.mp3",
        "storageType": "url",
        "fileName": "15.If I Had a Chicken - Kevin MacLeod.mp3",
        "fileSize": 6010000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/16.Invisible%20-%20Vibe%20Tracks.mp3",
        "storageType": "url",
        "fileName": "16.Invisible - Vibe Tracks.mp3",
        "fileSize": 9130000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/17.Jack%20in%20the%20Box%20-%20Silent%20Partner.mp3",
        "storageType": "url",
        "fileName": "17.Jack in the Box - Silent Partner.mp3",
        "fileSize": 4770000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/18.Jigsaw%20Puzzle%20-%20The%20Green%20Orbs.mp3",
        "storageType": "url",
        "fileName": "18.Jigsaw Puzzle - The Green Orbs.mp3",
        "fileSize": 5510000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/19.Morning%20Stroll%20-%20Josh%20Kirsch_Media%20Right%20Productions.mp3",
        "storageType": "url",
        "fileName": "19.Morning Stroll - Josh Kirsch_Media Right Productions.mp3",
        "fileSize": 3930000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/20.Mr.%20Turtle%20-%20The%20Green%20Orbs.mp3",
        "storageType": "url",
        "fileName": "20.Mr. Turtle - The Green Orbs.mp3",
        "fileSize": 4950000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/21.Osaka%20Rain%20-%20ALBIS.mp3",
        "storageType": "url",
        "fileName": "21.Osaka Rain - ALBIS.mp3",
        "fileSize": 4340000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/22.Ponies%20and%20Balloons%20-%20The%20Green%20Orbs.mp3",
        "storageType": "url",
        "fileName": "22.Ponies and Balloons - The Green Orbs.mp3",
        "fileSize": 7320000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/23.Rainy%20Day%20Games%20-%20The%20Green%20Orbs.mp3",
        "storageType": "url",
        "fileName": "23.Rainy Day Games - The Green Orbs.mp3",
        "fileSize": 4940000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/24.Sabana%20Havana%20-%20Jimmy%20Fontanez_Media%20Right%20Productions.mp3",
        "storageType": "url",
        "fileName": "24.Sabana Havana - Jimmy Fontanez_Media Right Productions.mp3",
        "fileSize": 4340000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/25.Sand%20Castles%20-%20The%20Green%20Orbs.mp3",
        "storageType": "url",
        "fileName": "25.Sand Castles - The Green Orbs.mp3",
        "fileSize": 5830000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/26.Snack%20Time%20-%20The%20Green%20Orbs.mp3",
        "storageType": "url",
        "fileName": "26.Snack Time - The Green Orbs.mp3",
        "fileSize": 4830000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/27.Splashing%20Around%20-%20The%20Green%20Orbs.mp3",
        "storageType": "url",
        "fileName": "27.Splashing Around - The Green Orbs.mp3",
        "fileSize": 6190000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/28.Spring%20In%20My%20Step%20-%20Silent%20Partner.mp3",
        "storageType": "url",
        "fileName": "28.Spring In My Step - Silent Partner.mp3",
        "fileSize": 4750000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/29.Springtime%20Family%20Band%20-%20The%20Green%20Orbs.mp3",
        "storageType": "url",
        "fileName": "29.Springtime Family Band - The Green Orbs.mp3",
        "fileSize": 5520000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/30.Sugar%20Zone%20-%20Silent%20Partner.mp3",
        "storageType": "url",
        "fileName": "30.Sugar Zone - Silent Partner.mp3",
        "fileSize": 4560000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/31.Tonto%20-%20Silent%20Partner.mp3",
        "storageType": "url",
        "fileName": "31.Tonto - Silent Partner.mp3",
        "fileSize": 6610000,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/32.Vacation%20Uke%20-%20ALBIS.mp3",
        "storageType": "url",
        "fileName": "32.Vacation Uke - ALBIS.mp3",
        "fileSize": 0,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/33.Walking%20the%20Dog%20-%20Silent%20Partner.mp3",
        "storageType": "url",
        "fileName": "33.Walking the Dog - Silent Partner.mp3",
        "fileSize": 0,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/34.Whistling%20Down%20the%20Road%20-%20Silent%20Partner.mp3",
        "storageType": "url",
        "fileName": "34.Whistling Down the Road - Silent Partner.mp3",
        "fileSize": 0,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    },
    {
        "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/bgm/35.Witness%20-%20Mikos%20Da%20Gawd.mp3",
        "storageType": "url",
        "fileName": "35.Witness - Mikos Da Gawd.mp3",
        "fileSize": 0,
        "mimeType": "audio/mpeg",
        "duration": 0,
        "width": 0,
        "height": 0,
        "fps": 0,
        "codec": "unknown",
        "bitrate": 0,
        "tags": ["system", "bgm", "preset"],
        "createdAt": Date.now(),
        "updatedAt": Date.now()
    }
];
